import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DropdownFilterService } from 'src/app/services/index-service';
import { arrayToPipeString } from 'src/app/shared/helper/custom-function';

@Component({
	selector: 'app-province-filter',
	template: `
		<app-select-filter 
			[hasIcon] = "hasIcon"
			bindLabel = "name"
			bindValue = "id"
			placeholder = "Select City"
			label = "City"
			[clearable]="multiple"
			[multiple] = "multiple"
			[items] = "metadata.data"
			[(value)] = value
			(valueChange)="valueChange.emit(value)"
		>
		</app-select-filter>
    `,
})

export class AppProvinceFilterComponent implements OnInit {
	@Input() multiple = false;
	@Input() value: number = null;
	@Output() valueChange = new EventEmitter();
	@Input() regionIds: number[] = null;
	@Input() hasIcon = false;
	metadata = {
		data: [],
		limit: 100,
		total: 0,
		search: '',
	}
	constructor(private dropdownFilter: DropdownFilterService) { }

	ngOnInit() {
		this.getProvinces();
	}

	getProvinces() {
		let mtd = this.metadata;
		const params = {
			regionIds: arrayToPipeString(this.regionIds),
		}
		if (!mtd.data.length || mtd.data.length < mtd.total) {
			this.dropdownFilter
				.getCities(params)
				.subscribe((res: any) => {
					const mappedData = (res.data || []).map(d => {
						return {
							id: d.id,
							name: d.name,
						}
					})
					mtd.data = [...mtd.data, ...mappedData];
					mtd.total = res.metadata.total;

					if (mtd.data.length && mtd.data.length < mtd.total) this.getProvinces();
					else {
						if (!this.multiple) {
							mtd.data.unshift({
								id: '',
								name: 'All',
							});
							this.value = this.value || mtd.data[0].id;
						}
					}
				});
		}

	}

	refresh() {
		/***** wait until regionId is successfully transfer *****/
		setTimeout(() => {
			this.value = null;
			this.metadata.data = [];
			this.getProvinces();
		}, 500);

	}
}